import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import { BehaviorTrackerBase } from './BehaviorTrackerBase';

const DEFAULT_EXIT_INTENT_THRESHOLD = 5;

export class ExitIntentTracker extends BehaviorTrackerBase {
  private fired = false;

  constructor(context: PixelRuntimeContext) {
    super(context);
  }

  protected onInit(): void {
    if (!this.isDocumentAvailable()) return;

    this.fired = false;
    this.addDocumentListener(
      'mousemove',
      (event: MouseEvent) => this.handleMouseMove(event),
      { passive: true }
    );
  }

  protected onDestroy(): void {
    this.fired = false;
  }

  private handleMouseMove(event: MouseEvent): void {
    if (this.fired) return;
    if (event.clientY > DEFAULT_EXIT_INTENT_THRESHOLD) return;

    this.fired = true;
    const now = Date.now();

    this.dispatchEngagement({
      type: 'EXIT_INTENT',
      category: 'ENGAGEMENT',
      triggeredAt: now,
      clientY: event.clientY,
    });
  }
}
